
import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useTranslator } from '@jutro/locale';
import { withRouter } from 'react-router-dom';
import { MLTagManagerService } from 'ml-portals-services-react';
import { MLNotificationBlockUtil } from 'ml-portals-util-react';
import { ClaimService } from 'gw-capability-claim';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { MLAlertGroupComponent } from 'ml-components-common-react';

import MLClaimSummariesComponent from '../../components/MLClaimSummaries/MLClaimSummariesComponent'

import metadata from './MLClaimList.metadata.json5';
import messages from './MLClaimList.messages';
import styles from './MLClaimList.module.scss';

function MLClaimList(props) {
    const {
        history
    } = props;
    const translator = useTranslator();
    const { authHeader } = useAuthentication();
    const { addErrorAlert } = MLNotificationBlockUtil();
    const [claims, updateClaims] = useState([]);
    const [claimError, updateClaimError] = useState();

    useEffect(() => {
        const claimSummaryPromise = ClaimService.getClaimSummaries({claimStates: ['open', 'draft', 'closed', 'archived']}, null, authHeader);
        claimSummaryPromise.then((_claims) => {
            updateClaims(_claims.items);
            updateClaimError();
        }).catch((e) => {
            console.error(e);
            updateClaimError(translator(messages.claimError))
            addErrorAlert(messages.claimError, 'claimError');
        })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const fileClaim = () => {
        MLTagManagerService.sendLinkClickEvent(`Claims_FILE A CLAIM`);
        history.push("/fnol");
    }

    const isClaimsListEmpty = () => {
        return _.isUndefined(claims) || claims.length === 0;
    }

    const getInformationToIncludeList = () => {
        return <>
            <li>{translator(messages.ContactInformation)}</li>
            <li>{translator(messages.PoliceInformation)}</li>
            <li>{translator(messages.PhotoInformation)}</li>
        </>
    }

    const getWhatHappensNextList = () => {
        return <>
            <li>{translator(messages.ClaimConsultantAssigned)}</li>
            <li>
                {translator(messages.ClaimConsultantAdditionalInfo)}
                <ul className="styled-ul-list-nested">
                    <li>{translator(messages.InsuranceInformation)}</li>
                    <li>{translator(messages.PoliceInformation2)}</li>
                </ul>
            </li>
        </>
    }

    const overrides = {
        NoPriorClaimsExist: {
            visible: isClaimsListEmpty() && claimError===null
        },
        YourClaims: {
            visible: !isClaimsListEmpty()
        },
        /** REMOVE THIS BLOCK ONCE FNOL IS READY
         *  START 
         */
        FileAClaimTwoHoursText: {
            content: "The portal is temporarily unavailable due to maintenance, please contact us at 800-854-6011 to file your claim. Thank you."
        },
        FileAClaimButton: {
            visible: false
        },
        /**
         * END 
         */
        YourClaimsSummaries: {
            claims,
            history
        },
        InformationToIncludeList: {
            content: getInformationToIncludeList()
        },
        WhatHappensNextList: {
            content: getWhatHappensNextList()
        }
    };
    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            MLAlertGroupComponent,
            MLClaimSummariesComponent
        },
        resolveCallbackMap: {
            fileClaim
        }
    };

    return <MetadataContent uiProps={metadata.pageContent} overrideProps={overrides} {...resolvers} />;
}

export default withRouter(MLClaimList);
